// AUTOGENERATED FILE
// source: scripts/generate-product-types-templates.ts

import React from 'react'
import { ReactComponent as TemplateSVG } from '../../../../../assets/product-templates/svg/yope.svg'

export const YopeTemplate = (props: React.SVGProps<SVGSVGElement>) => {
  return <TemplateSVG {...props} />
}
